import React from 'react';
import { Skeleton } from './Skeleton';

const EventSkeleton: React.FC = () => {
  return (
    <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white">
      {/* Image placeholder */}
      <Skeleton height="200px" />
      
      {/* Content area */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <Skeleton width="80%" height="1.5rem" />
        
        {/* Date */}
        <Skeleton width="60%" />
        
        {/* Location */}
        <Skeleton width="70%" />
        
        {/* Price */}
        <div className="flex justify-between items-center mt-4">
          <Skeleton width="40%" />
          <Skeleton width="30%" height="2rem" rounded />
        </div>
      </div>
    </div>
  );
};

export const EventSkeletonGroup: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <EventSkeleton key={index} />
      ))}
    </div>
  );
};

export default EventSkeleton; 